import Service from "../../Service";

const resource = "visit/";

export default {
    
    save(parameters, requestID) {
        return Service.post(resource + "saveActivityCultural", parameters, {
            params: {
                requestID: requestID,
            },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "paginationActivityCultural", parameters, {
            params: { requestID }
        });
    }
};